import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {FinanceService} from '../../../services/api/finance.service';
import {FinanceWalletModel} from '../../../models/finance.model';
import {PaymentTransactionModel} from '../../../models/contract.model';
import {AlertService} from '../../../services/notify/alert.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ModalService} from '../../../services/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-replenishment',
    templateUrl: './replenishment.component.html',
    styleUrls: ['./replenishment.component.scss']
})
export class ReplenishmentComponent implements OnInit, AfterViewInit {
    @ViewChild('replenishmentView') public replenishmentView: TemplateRef<any>;
    @Input() public wallet: FinanceWalletModel;
    @Output() public emitFinish: EventEmitter<boolean> = new EventEmitter<boolean>();
    isLockButton = false;

    constructor(
        protected financeService: FinanceService,
        protected alert: AlertService,
        protected modalService: ModalService,
        protected translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        const sub = this.modalService.emitOnClose.subscribe(() => {
            this.emitFinish.emit();
            sub.unsubscribe();
        });
    }

    ngAfterViewInit(): void {
        this.modalService.openTemplateModal(this.replenishmentView);
    }

    onReplenishmentEvent($total, modal: NgbModalRef = null): void {
        if (!$total.value) {
            this.alert.setAlert(this.translate.instant('ALERTS.SET_TOTAL'), 'blue');
        } else {
            this.isLockButton = true;
            this.financeService.createReplenishmentTransaction(this.wallet.guid, $total.value, this.wallet.owner_type)
                .subscribe({
                    next: (res: { transaction: PaymentTransactionModel }) => {
                        this.alert.setAlert(this.translate.instant('ALERTS.NEW_TRANSACTION',
                            {guid: res.transaction.guid, total: res.transaction.total}), 'green');

                        this.emitFinish.emit(true);
                        setTimeout(() => {
                            this.isLockButton = false;
                        }, 500);
                        modal.close();
                    }, error: error => {
                        this.alert.setAlert(error.message, 'blue');
                        this.isLockButton = false;
                    }
                });
        }
    }
}
